/* BrameCam — barre d'achat mobile (v4, 29/09/2026)

   v5 (29/09/2026) : meme logique sur ordinateur ("Choisir mon pack",
   puis ajout du pack choisi). Le theme n'affichait jamais la barre sur
   ordinateur car le bouton d'achat natif est masque sur cette fiche.

   v4 : tant que le bloc packs n'a pas ete atteint, la barre est visible
   des l'arrivee sur la fiche, affiche "Choisir mon pack" et fait defiler
   jusqu'aux packs au lieu d'ajouter directement une camera : le visiteur
   voit toujours le choix Duo/Trio.
   Une fois le bloc packs atteint, la barre reprend son libelle et son
   ajout au panier habituels.

   Historique v3 (13/09/2026) :
   Reprend la main sur <sticky-atc> pour les fiches equipees du bloc packs.

   Regle d'apparition : la barre sort des que le prix a quitte le haut de
   l'ecran, et elle y reste. Elle ne s'efface que si le vrai bouton
   d'ajout de la fiche vient occuper le bas de l'ecran, c'est-a-dire la
   place exacte de la barre : on evite le chevauchement, pas le doublon.

   v2 (abandonnee) : la barre se retirait des que le bouton de la fiche
   etait visible n'importe ou a l'ecran. Sur mobile ce bouton est plus
   d'un ecran sous le prix : la barre sortait tot, disparaissait pendant
   tout le bloc packs, et ne revenait durablement qu'au meme endroit
   qu'avant. Gain nul a l'usage.

   L'ancien reglage inline de la fiche continue de poser ses classes
   (bc-pack-gated / bc-bundle-synced / bc-pack-passed) : ses regles CSS
   portent un selecteur d'ID, donc elles gagneraient sur les notres. On
   les retire en continu plutot que d'essayer de surencherir.

   Si ce script ne s'execute pas, la fiche retombe sur l'ancien reglage. */
(function () {
  'use strict';

  var MQ = window.matchMedia('(max-width: 749px)');
  var LEGACY = ['bc-pack-gated', 'bc-bundle-synced', 'bc-pack-passed'];

  function strip(bar) {
    for (var i = 0; i < LEGACY.length; i++) {
      if (bar.classList.contains(LEGACY[i])) bar.classList.remove(LEGACY[i]);
    }
    if (!bar.classList.contains('bc-atc')) bar.classList.add('bc-atc');
  }

  function setup() {
    var bar = document.querySelector('sticky-atc');
    if (!bar || bar.getAttribute('data-bc-atc') === '1') return;

    /* On ne touche qu'aux fiches deja passees au reglage BrameCam. */
    var eligible =
      bar.classList.contains('bc-pack-gated') ||
      bar.classList.contains('bc-bundle-synced') ||
      !!document.querySelector('[data-bc-pack]');
    if (!eligible) return;

    bar.setAttribute('data-bc-atc', '1');
    strip(bar);

    /* L'ancien script repose ses classes au scroll : on les balaie. */
    if ('MutationObserver' in window) {
      new MutationObserver(function () {
        strip(bar);
      }).observe(bar, { attributes: true, attributeFilter: ['class'] });
    }

    var info = document.querySelector('product-info') || document;
    var anchor =
      info.querySelector('.price') ||
      info.querySelector('.product__title') ||
      info.querySelector('h1');
    var inline =
      document.querySelector('.bc-pack__cta') ||
      info.querySelector('.product-form__submit');

    /* v4 : mode "Choisir mon pack" tant que les packs sont plus bas. */
    var packs = document.querySelector('[data-bc-pack]');
    var addBtn = bar.querySelector('.sticky-atc__add_button');
    if (packs && addBtn && !addBtn.querySelector('.bc-atc__choose')) {
      var choose = document.createElement('span');
      choose.className = 'bc-atc__choose';
      choose.textContent = 'Choisir mon pack';
      addBtn.appendChild(choose);
    }

    function packsAhead() {
      if (!packs) return false;
      return packs.getBoundingClientRect().top > window.innerHeight * 0.6;
    }

    function packButton() {
      return packs ? packs.querySelector('[data-bc-add], [data-bc-submit]') : null;
    }

    /* Ecoute en capture sur la barre : passe avant le gestionnaire
       inline du bouton, qui declencherait l'ajout au panier.
       - mode "Choisir mon pack" (mobile et ordinateur) : defilement
         jusqu'aux packs, aucun ajout ;
       - ordinateur, mode ajout : on declenche le bouton du bloc packs,
         pour ajouter le pack reellement choisi (le bouton natif du theme
         n'ajouterait qu'une camera). Sur mobile, l'ancien gestionnaire
         inline fait deja ce travail. */
    bar.addEventListener('click', function (event) {
      if (!packs || !event.target.closest('.sticky-atc__add_button')) return;
      var choose = bar.classList.contains('bc-atc--choose');
      if (!choose && MQ.matches) return;
      event.preventDefault();
      event.stopPropagation();
      if (choose) {
        var top = packs.getBoundingClientRect().top + window.pageYOffset - 90;
        var smooth = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
        window.scrollTo({ top: Math.max(top, 0), behavior: smooth ? 'smooth' : 'auto' });
        return;
      }
      var pb = packButton();
      if (pb && !pb.disabled) pb.click();
    }, true);

    var ticking = false;

    function evaluate() {
      ticking = false;
      var ahead = packsAhead();

      if (!MQ.matches) {
        /* Ordinateur (v4) : "Choisir mon pack" tant que les packs sont
           plus bas ; ensuite la barre n'apparait que si le bouton du bloc
           packs n'est plus a l'ecran (pas de doublon visible). */
        var onDesk = ahead;
        if (!ahead && inline) {
          var ri = inline.getBoundingClientRect();
          onDesk = !(ri.top < window.innerHeight && ri.bottom > 0);
        }
        if (!packs) onDesk = false;
        bar.classList.toggle('bc-atc--choose', ahead);
        bar.classList.toggle('bc-atc--on', onDesk);
        document.body.classList.remove('bc-atc-visible');
        return;
      }

      /* 1. Le prix a-t-il quitte le haut de l'ecran ? */
      var passed = true;
      if (anchor) passed = anchor.getBoundingClientRect().bottom <= 0;

      /* 2. Le bouton de la fiche occupe-t-il la place de la barre ? */
      var collides = false;
      if (inline) {
        var zone = bar.offsetHeight || 80;
        var r = inline.getBoundingClientRect();
        collides =
          r.bottom > window.innerHeight - zone - 8 && r.top < window.innerHeight;
      }

      /* v4 : en mode "Choisir mon pack", la barre est visible des
         l'arrivee sur la fiche (sur mobile le prix est sous la galerie,
         hors du premier ecran). */
      var on = (passed || ahead) && !collides;
      bar.classList.toggle('bc-atc--choose', ahead);
      bar.classList.toggle('bc-atc--on', on);
      document.body.classList.toggle('bc-atc-visible', on);
    }

    function schedule() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(evaluate);
    }

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    if (MQ.addEventListener) MQ.addEventListener('change', schedule);
    else if (MQ.addListener) MQ.addListener(schedule);

    evaluate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }

  /* Editeur de theme : la section produit peut etre re-rendue. */
  document.addEventListener('shopify:section:load', setup);
})();